module.exports = __webpack_public_path__ + "img/DE01175.617f3573.png";